<script lang="ts">
    import { cx } from '$lib/utils/cx.js';
    import MediaImage from '$components/MediaImage/MediaImage.svelte';
    import { melt } from '@melt-ui/svelte';
    import { type MeltWithAction, meltWithActionDefault } from '$lib/utils/melt';

    export let iconClass: string | null = null;
    export let iconUrl: string | null = null;
    export let imageId: number | null = null;
    export let srLabel: string | null = null;
    export let label: string | null = null;
    export let withCaret: boolean = false;

    export let triggerAttrs: Record<string, string | undefined> = {};
    export let open: boolean = false;

    export let meltItem: MeltWithAction = meltWithActionDefault;

    export let href: string | undefined = undefined;

    export let reload = true;

    export let htmlElement: 'a' | 'button' = 'button';

    export let countBadge: number | null = null;

    export let onClick: (event: MouseEvent) => void = () => {};
</script>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<svelte:element
    this={htmlElement}
    data-sveltekit-reload={reload}
    use:melt={meltItem}
    on:click={onClick}
    {href}
    data-open={open ? 'true' : undefined}
    class={cx(
        'btn-reset flex items-center justify-center gap-x-[8px]',
        'h-full hover:bg-brand-navbar-blue-alt data-[open]:bg-brand-navbar-blue-alt focus:bg-brand-navbar-blue-alt',
        'outline-none',
        'group',
        label != null ? 'px-[16px]' : 'px-[2px] ms:px-[4px] mm:px-[8px]',
    )}
    {...triggerAttrs}
>
    {#if iconUrl != null}
        <img
            class="size-[32px] object-contain"
            src={iconUrl}
            alt={srLabel ?? label ?? ''}
        />
    {/if}
    {#if iconClass != null || imageId != null}
        <div
            class={cx(
                'size-[40px]',
                'flex items-center justify-center',
                'bg-brand-navbar-blue-alt group-hover:bg-brand-blue group-focus:bg-brand-blue group-data-[open]:bg-brand-blue',
                'rounded-full',
                'text-white relative',
            )}
        >
            {#if srLabel != null}
                <span class="sr-only">{srLabel}</span>
            {/if}
            {#if imageId != null}
                <MediaImage
                    mediaId={imageId}
                    format="w100"
                    class="size-[40px] object-cover group-hover:opacity-75 rounded-full"
                />
            {:else if iconClass}
                <i class={cx(iconClass, 'text-22')} aria-hidden={true} />
            {/if}
            {#if countBadge != null}
                <span
                    class={cx(
                        'absolute top-[-5px] left-[25px]',
                        'min-w-[18px] h-[19px] bg-brand-yellow px-[4px]',
                        'border-solid border-[3px] border-brand-navbar-blue-alt',
                        'rounded-full',
                        'flex items-center justify-center',
                        'text-gray-800 text-12/[120%] tracking-[0.5px] font-bold',
                    )}
                >
                    {countBadge}
                </span>
            {/if}
        </div>
    {/if}
    {#if label != null}
        <span
            class={cx(
                'text-white hover:text-white focus:text-white',
                'text-14/[120%] font-medium',
            )}
        >
            {label}
            {#if withCaret}
                <i
                    class={cx(open ? 'tnp tnp-chevron-up' : 'tnp tnp-chevron-down')}
                    aria-hidden={true}
                />
            {/if}
        </span>
    {/if}
</svelte:element>
